import styled from '@emotion/styled'
import type { FC } from 'react'
import sanitizeHtml from 'sanitize-html'

import AccordionBase, * as Accordion from '@segment/matcha/recipes/Accordion'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import RichText from '@segment/matcha/recipes/RichText'

import { useActiveState } from '@segment/utils/useActiveState'

import type { FAQ as SingleFAQ } from './data'
import { faqs } from './data'

interface Data {
  heading: string
  faqs: SingleFAQ[]
}

const data: Data = {
  heading: `Frequently asked questions`,
  faqs,
}

const FAQ: FC = () => {
  const items = new Array(data.faqs.length).fill(false)
  const { activeItems, toggle } = useActiveState(items, {
    allowMultipleActive: true,
  })
  return (
    <StyledSectionBase variant="centered" id="faq">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading
            tag="h2"
            variant="h2"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(data.heading),
            }}
          ></CopyText.Heading>
        </CopyTextBase>
      </Section.Copy>
      <StyledSectionContents>
        {activeItems.map((active, index) => (
          <AccordionBase key={`item-${index}`}>
            <Accordion.Header onClick={() => toggle(index)}>
              <Accordion.TitleWrapper>
                <Accordion.Title opened={active} tag="h3">
                  {data.faqs[index].title}
                </Accordion.Title>
              </Accordion.TitleWrapper>
              <Accordion.Icon opened={active} />
            </Accordion.Header>
            <Accordion.Body>
              {active && (
                <Accordion.ContentWrapper>
                  <Accordion.Text>
                    <RichText data={data.faqs[index].description} />
                  </Accordion.Text>
                </Accordion.ContentWrapper>
              )}
            </Accordion.Body>
          </AccordionBase>
        ))}
      </StyledSectionContents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  overflow: inherit;

  ${Section.Wrapper} {
    justify-content: stretch;
  }
`

const StyledSectionContents = styled(Section.Contents)`
  max-width: 844px;
  width: 100%;
`

export default FAQ
